<h1 mat-dialog-title>Confirm Delete</h1>
<div mat-dialog-content [formGroup]="deletionForm" class="modal-content">
    <h3>Are you sure you want to delete this {{context}}?</h3>
</div>
<div mat-dialog-actions>
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="deletionForm.value" color="warn">Delete</button>
</div>
